<template>
  <div>
    <v-dialog
      v-if="isShowDialog"
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      transition="dialog-transition"
    >
      <v-card class="d-flex align-end flex-column">
        <v-card-text>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="d-flex justify-space-around">
                <v-col class="col-4 text-left">
                </v-col>
                <v-col class="col-4 text-center">
                  <h1 class="mt-8">EDIT TARIFF</h1>
                </v-col>
                <v-col class="col-4 text-right">
                  <v-btn :disabled="loading" outlined class="mt-6" @click="hideEditTariffs" large>
                    <v-icon color="white">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col class="col-12 mt-8">
                  <v-row no-gutters>
                    <v-col class="col-5 mt-5">
                      <v-text-field
                        :disabled="(loading)"
                        label="Enter Tariff Name"
                        outlined
                        v-model="TariffEditDto.Name"
                      ></v-text-field>
                      <v-select
                        :disabled="(loading)"
                        outlined
                        v-model="TariffEditDto.SupplierId"
                        :items="getSubjectCreationDatas.suppliers"
                        item-text="title"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Enter Provider"
                        persistent-hint
                      ></v-select>
                      <v-text-field
                        :disabled="(loading)"
                        label="Enter Price"
                        outlined
                        v-model="TariffEditDto.Description"
                      ></v-text-field>
                      <v-select
                        :disabled="(loading)"
                        outlined
                        v-model="TariffEditDto.MeasureTypeId"
                        :items="getSubjectCreationDatas.measureTypes"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Enter Type"
                        persistent-hint
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="col-12 d-flex justify-end">
                  <v-btn :disabled="loading || isNotValidStep1" depressed outlined large class="mr-4" @click="editTarriff">
                    SAVE
                  </v-btn>
                  <v-btn :disabled="loading" depressed outlined large @click="hideEditTariffs">
                    CANCEL
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog'],
    name: 'EditTariff',
    data(){
      return {
        loading: false,
        TariffEditDto:{
          Name: null,
          MeasureTypeId: null,
          Description: null,
          SupplierId: null,
          id: null
        }
      }
    },
    components:{
    },
    computed:{
      ...mapGetters(['getSubjectCreationDatas']),
      isNotValidStep1(){
        return Object.entries(this.TariffEditDto).filter(data => data[1] == null).length > 0
      },
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    mounted(){
      this.$root.$on("editTariff", (item) => {
        this.TariffEditDto.Name = item.data.name
        this.TariffEditDto.MeasureTypeId = item.data.measureTypeId
        this.TariffEditDto.Description = item.data.description
        this.TariffEditDto.SupplierId = item.data.supplierId
        this.TariffEditDto.id = item.data.id
      })
    },
    methods:{
      ...mapActions(['editDataTariff']),
      async editTarriff(){
        this.loading = true
        this.$root.$emit('loading', "start")
        await this.editDataTariff(this.TariffEditDto)
        .then(res => {
          console.log(res)
          this.$root.$emit('loading', "end")
          this.$noty.success(`Success`)
          this.loading = false
          this.$root.$emit("updateTariffTable")
        })
        .catch(er => {
          console.log(er)
          this.$root.$emit('loading', "end")
          this.$noty.error(`Error: ${er.description}`)
          this.loading = false
        })
      },
      hideEditTariffs(){
        this.$emit('hideEditTariffs')
      }
    }
  }
</script>
<style>
</style>
